module.exports = __webpack_public_path__ + "img/phone-white.cbcd8d73.svg";